import React, { useState } from 'react';
import { UsersIcon } from '@heroicons/react/24/outline';
import useRouter from '../../hooks/useRouter';
import Urls from '../project-create/Urls';
import DataCard from '../profile-edit/DataCard';
import { PayloadStates } from '@lore/utils';
import useProjectTags from '../../hooks/useProjectTags';
import TagTypes from '../../constants/TagTypes';
import usePageRouter from '../../dialogs-routable/_hooks/usePageRouter';

export default function Participants(props) {
  const { project } = props;

  const { history } = usePageRouter();

  const [timestamp] = useState(new Date().toISOString());

  const projectParticipants = useProjectTags(project, TagTypes.Participant, timestamp);

  let subtitle = '';

  if (projectParticipants.state === PayloadStates.FETCHING) {
    subtitle = '...';
  } else {
    subtitle = projectParticipants.data.map(function(projectParticipant, index) {
      return (
        <div key={index}>
          {projectParticipant.data.name}
        </div>
      );
    });
  }

  return (
    <DataCard
      title="Participants"
      icon={UsersIcon}
      subtitle={subtitle || '(not provided)'}
      onClick={() => history.push(Urls(project).PARTICIPANTS)}
    />
  );
};
